export enum ErrorCode {
  INVALID_CAPTCHA = 'INVALID_CAPTCHA',
  OPERATION_LOCKED = 'OPERATION_LOCKED',
}
